<template>
  <div>
    <div v-if="achType === '论文'">
      <div class="flex items-center">
        <div class="achTitle pointer" @click="goDetails('/paperDetail', achData.id)">
          {{ achData.title }}
        </div>
        <div v-for="(jcrItem, jcrIndex) in achData.jcrPartitionList" :key="jcrIndex">
          <div
            v-if="jcrItem"
            style="
              background-color: #1241C9;
              border-radius: 3px;
              font-size: 12px;
              color: white;
              padding: 3px 10px;
              margin-left: 10px;
            "
          >
            {{ jcrItem }}
          </div>
        </div>
      </div>
      <div>
        <div class="flex flex-wrap">
          <div class="flex achLine wrap">
            <div style="white-space: nowrap">作者：</div>
            <div
              class="flex items-center"
              v-for="(personItem, i) in achData.authorList.length > 6
                ? achData.authorList.slice(0, 6)
                : achData.authorList"
              :key="i"
              style="margin-right: 10px"
            >
              <img
                :src="personItem.avatarUrl"
                width="14"
                height="14"
                style="border-radius: 50%; margin-right: 5px"
              />
              <div style="white-space: nowrap">{{ personItem.name  || personItem.scholarName }}</div>
            </div>
            <p v-if="achData.authorList.length > 6">...</p>
            <p v-if="achData.authorList.length === 0">-</p>
          </div>
        </div>
        <div class="flex">
          <div class="achLine ellipsis" style="white-space: nowrap;max-width: 650px" :title='achData.journalConf || achData.venue'>
            <span>出版物：</span>{{ achData.journalConf  || achData.venue || '-' }}
          </div>
          <div class="achLine"><span>卷号：</span>{{ achData.volume || '-' }}</div>
        </div>
        <div class="flex">
          <div class="achLine"><span>引用次数：</span>{{ achData.citationCount || achData.citationNum || '0'  }}</div>
          <div class="achLine"><span>发表时间：</span>{{ achData.pubDate || achData.year }}</div>
        </div>
      </div>
    </div>
    <div v-if="achType === '专利'">
      <div class="achTitle pointer" @click="goDetails('/patentDetail', achData.id)">
        {{ achData.title }}
      </div>
      <div>
        <div class="flex">
          <div class="flex achLine">
            <span>发明人：</span>
            <div
              class="flex items-center"
              v-for="(personItem, i) in achData.authors"
              :key="i"
              style="margin-right: 10px"
            >
              <img
                :src="personItem.avatarUrl"
                width="14"
                height="14"
                style="border-radius: 50%; margin-right: 5px"
              />
              <div>{{ personItem.scholarName }}</div>
            </div>
          </div>
          <div class="achLine"><span>申请人：</span>{{ achData.applicantName || '-' }}</div>
          <div class="achLine"><span>申请时间：</span>{{ achData.year }}</div>
        </div>
        <div class="flex">
          <div class="achLine"><span>专利类型：</span>{{ achData.patentType }}</div>
          <div class="achLine">
            <span>公开日期：</span>{{ formatToDate(achData.publicationDate) }}
          </div>
          <div class="achLine"><span>公开(公告)号：</span>{{ achData.publicationNum || '-' }}</div>
          <div class="achLine"><span>申请号：</span>{{ achData.applicationNum || '-' }}</div>
        </div>
      </div>
    </div>
    <div v-if="achType === '项目'" class="achievement-item project-item">
      <h3 class="title">
        <span @click="toDetail(achData.id, '/projectDetail')">{{ achData.title || '-' }}</span>
      </h3>
      <div class="info">
        <div class="flex items-center" v-if="achData.leader">
          <span style="color: #667085; font-size: 14px">负责人：</span>
          <p
            v-if="achData.leader"
            style="
              cursor: pointer;
              font-size: 14px;
              max-width: 300px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #101828;
            "
            class="flex items-center"
            @click="goPersonalDetails(achData.leader.id)"
          >
            <el-avatar :size="22" :src="achData.leader && achData.leader.avatar"></el-avatar>
            <span style="margin-left: 10px">{{
                achData.leader && achData.leader.scholarName
              }}</span>
          </p>
          <p
            v-else
            style="
              font-size: 14px;
              max-width: 300px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #101828;
            "
          >
            -
          </p>
        </div>
        <div
          v-if="achData.startYear"
          class="flex items-center"
          style="margin-left: 30px; color: #667085; font-size: 14px"
        >
          <span>批准年份：</span>
          <p
            style="
              font-size: 14px;
              max-width: 300px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #101828;
            "
          >
            {{ achData.startYear || '' }}
          </p>
        </div>
        <div
          v-if="achData.typeFirst"
          class="flex items-center"
          style="margin-left: 30px; color: #667085; font-size: 14px"
        >
          <span>项目类别：</span>
          <p
            style="
              font-size: 14px;
              max-width: 300px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #101828;
            "
          >
            {{ achData.typeFirst || '-' }}
          </p>
        </div>
        <div
          v-if="achData.projectSource"
          class="flex items-center"
          style="margin-left: 30px; color: #667085; font-size: 14px"
        >
          <span>项目来源：</span>
          <p
            style="
              font-size: 14px;
              max-width: 300px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #101828;
            "
          >
            {{ achData.projectSource || '-' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatToDate} from '@/utils/dateUtil'

export default {
  name: 'achievementItem',
  props: ['achType', 'achData'],
  data() {
    return {
      formatToDate,
    };
  },
  created() {
  },
  methods: {
    goPersonalDetails(id) {
      if (id) {
        let obj = {
          name: 'talentDetail',
          query: {
            id: id,
          },
        };
        let routeData = this.$router.resolve(obj);
        window.open(routeData.href, '_blank');
      } else {
        this.$message.warning({
          message: '暂无详情数据',
          type: 'warning',
        });
      }
    },
    toDetail(id, path) {
      if (id) {
        this.$router.push({
          path: path,
          query: { id: id, isBack: '1', backName: this.backName },
        });
      } else {
        this.$message.warning({
          message: '无详情数据',
          type: 'warning',
        });
      }
    },
    /**
     * 跳转至详情页面
     */
    goDetails(path, id) {
      this.$router.push({ path: path, query: { id: id } });
    },
  },
};
</script>

<style scoped lang="less">
.achievementTitle {
  font-size: 14px;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 0;
  cursor: pointer;
  border-radius: 14px;
  margin-right: 14px;
}

.selectAchievementTitle {
  font-size: 14px;
  color: #1241C9;
  cursor: pointer;
  display: flex;
  margin-right: 14px;
  justify-content: center;
  align-items: center;
  padding: 7px 0;
  border-radius: 14px;
}

.achLine {
  color: #666666;
  margin-right: 22px;
  font-size: 14px;
  margin-top: 12px;

  span {
    color: #999999;
  }
}

.item-bottom {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 12px;
  margin-bottom: 15px;
}

.achTitle {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

.achievement-item {
  padding: 8px 0;

  &:not(:last-child) {
    border-bottom: 1px dashed #e8eaee;
  }

  .title {
    max-width: 1100px;
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    span {
      font-size: 16px;
      color: #101828;
      cursor: pointer;
      letter-spacing: 0.5px;

      &:hover {
       // color: #1241C9;
      }
    }
  }
}

.title {
  max-width: 1100px;
  text-align: start;
  line-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  span {
    font-size: 16px;
    color: #101828;
    cursor: pointer;
    letter-spacing: 0.5px;

    &:hover {
      // color: #1241C9;
    }
  }
}

.info {
  display: flex;
  align-items: center;
  margin-top: 6px;
  flex-wrap: wrap;

  infoLi {
    display: flex;
    align-items: center;
    margin-right: 30px;
    //margin-bottom: 6px;

    span {
      color: #667085;
      font-size: 14px;
    }

    p {
      font-size: 14px;
      max-width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #101828;
    }
  }

  li.inventor {
    p {
      margin-right: 10px;
      display: flex;
      align-items: center;

      span {
        color: #101828;
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
}
</style>
